import DataService from "../services/data.service";
import createInstance from "./interceptors";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api/user/";

class AuthService {
  login(user) {
    const instance = createInstance();

    return instance
      .post(API_URL + "authenticate", {
        login: user.login,
        senha: user.senha,
      })
      .then((response) => {
        if (response.data.token) {
          DataService.setUser(response.data);
        }

        return response.data;
      });
  }

  logout() {
    DataService.proceedLogout();
  }
}

export default new AuthService();
